export default __webpack_public_path__ + "static/media/cardano.4b59a6a3.svg";